<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t('ventasDeMateriasPrimas')}}</li>
                    </ol>
                </nav>
            </div>
            <!-- Usuario de company sectorizada: selector de sector en lugar de negocio -->
            <CabeceraInformes
                v-if="modoSectores && listaSectores.length > 0"
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="idTpv"
                :listTpv="listTpv"
                :listSectores="listaSectores"
                :idSector="idSector"
                :sectores="true"
                :dateto="dateto"
                :datefrom="datefrom"
                id="cabecera"
                :conTodos="true"
                :cargando="isLoadingCurrent"
                :disableBusinessSelect="hayConsultasEnCurso"
            />
            <CabeceraInformes
                v-else-if="!modoSectores"
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="idTpv"
                :listTpv="listTpv"
                :dateto="dateto"
                :datefrom="datefrom"
                id="cabecera"
                :conTodos="true"
                :cargando="isLoadingCurrent"
                :disableBusinessSelect="hayConsultasEnCurso"
            />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <!--<div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getTpv(),idsTPV=[], idFiltro=0">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">

                                <label for="listTPV">{{$t("TPV")}}</label>

                                <div class="row">
                                    <div class="col-8">
                                        <el-select class="select-default"
                                                   size="large"
                                                   v-model="idTpv"
                                                   filterable
                                                   @change="changeTPV()"
                                                   :placeholder="$t('seleccionaTpv')">
                                            <el-option v-for="tpv in listTpv"
                                                       class="select-primary"
                                                       :value="tpv.id"
                                                       :label="tpv.nameShow"
                                                       :key="tpv.id">
                                            </el-option>

                                        </el-select>

                                    </div>

                                    <div class="col-4">
                                        <button class="btn btn-primary"
                                                @click="openModal()"><i
                                                class="fa fa-filter"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getSalesProducts()">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->


            <div class="col-md-9" v-else-if="respuesta">
                <template>
                    <div class="row justify-content-between div-export">
                        <div class="col-md-4 text-left" style="margin-bottom: 4px">
                            <el-select class="select-default filterTag"
                                    size="large"
                                    filterable
                                    v-model="idFiltro"
                                    @change="onFiltroChange()"
                                    placeholder="Filtrar por etiqueta">
                                <el-option v-for="tag in filterTag "
                                        class="select-primary"
                                        :value="tag.id"
                                        :label="tag.name"
                                        :key="tag.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-md-8 col-xs-12 text-right" v-if="list.length>0"> 
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                    </div>
                </template>
               <div class="col-12 text-muted text-right" style="font-size: 12px; margin-bottom: 12px;" v-if="searchPerformed">
                    <i class="fa fa-info-circle"></i>
                    {{$t("avisoDatosUltimaConsulta")}}
                    <span v-if="lastUpdatedFormatted">{{$t("ultimaActualizacion")}}: {{lastUpdatedFormatted}}</span>
                </div>
                <template v-if="list.length > 0">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped text-nowrap">
                            <thead class="thead-dark">
                            <tr style="cursor: pointer;">
                                <th v-if="ordenacionProductos===0" @click="sortedArrayNameASC('name')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("producto")}}
                                </th>
                                <th v-else @click="sortedArrayNameDESC('nameTag')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("producto")}}
                                </th>
                                <th v-if="ordenacionBarcode === 0" @click="sortedArrayBarcodeASC('cod_ean')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("codigoBarras")}}
                                </th>
                                <th v-else @click="sortedArrayBarcodeDESC('cod_ean')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t("codigoBarras")}}
                                </th>
                                <th v-if="ordenacionProveedor===0" @click="sortedArrayNameProveedorASC('nameProveedor')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("proveedor")}}
                                </th>
                                <th v-else @click="sortedArrayNameProveedorDESC('nameProveedor')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t("proveedor")}}
                                </th>
                                <th v-if="ordenacionTag===0" @click="sortedArrayNameTagASC('nameTag')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("etiqueta")}}
                                </th>
                                <th v-else @click="sortedArrayNameTagDESC('nameTag')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t("etiqueta")}}
                                </th>
                                <th v-if="ordenarCantidad===0" @click="sortedArrayCantidadASC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("unidades")}}
                                </th>
                                <th v-else @click="sortedArrayCantidadDESC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t("unidades")}}
                                </th>
                                <th v-if="ordenarCantidad===0" @click="sortedArrayCantidadASC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("partes")}}
                                </th>
                                <th v-else @click="sortedArrayCantidadDESC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t("partes")}}
                                </th>
                                <th v-if="ordenarTipo===0" @click="sortedArrayTipoASC('tipo')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t('tipo')}}
                                </th>
                                <th v-else @click="sortedArrayTipoDESC('tipo')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t('tipo')}}
                                </th>
                                <th v-if="ordenarCosto===0" @click="sortedArrayCostoASC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t('coste')}}
                                </th>
                                <th v-else @click="sortedArrayCostoDESC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t('coste')}}
                                </th>
                                <th v-if="ordenarCosteConDto===0" @click="sortedArrayCosteConDtoASC('precioCompraConDto')">
                                    <i style="color: white" class="fa fa-angle-up"></i> Coste con Dto
                                </th>
                                <th v-else @click="sortedArrayCosteConDtoDESC('precioCompraConDto')">
                                    <i style="color: white" class="fa fa-angle-down"></i> Coste con Dto
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="obj in list">
                                <td>{{obj.name}}</td>
                                <td>{{obj.cod_ean}}</td>
                                <td>{{obj.nameProveedor}}</td>
                                <td>{{obj.nameTag}}</td>
                                <td>{{calcularUnidades(obj.units, obj.escandallo)}}</td>
                                <td>{{calcularPartes(obj.units,obj.escandallo)}}</td>
                                <!-- <td>
                                {{calcularUnidades(obj.units,obj.escandallo)}}
                                <template v-if="obj.escandallo>1">
                                        / {{calcularPartes(obj.units,obj.escandallo)}}
                                    </template>
                                </td> -->
                                <td>{{obj.type}}</td>
                                <td>
                                <template v-if="obj.escandallo>1">
                                    {{(obj.precioCompra / obj.escandallo) * obj.units
                                        | currency}}
                                </template>
                                <template v-else>
                                    {{obj.precioCompra * obj.units
                                        | currency}}
                                </template>
                                </td>
                                <td>
                                <template v-if="obj.escandallo>1">
                                    {{(obj.precioCompraConDto / obj.escandallo) * obj.units
                                        | currency}} ({{obj.dtoCompra}}%)
                                </template>
                                <template v-else>
                                    {{obj.precioCompraConDto * obj.units
                                        | currency}} ({{obj.dtoCompra}}%)
                                </template>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr class="table-success">
                                <td><strong>{{$t("total")}}</strong></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><strong>{{ getTotalPrecio | currency}}</strong></td>
                                <td><strong>{{ getTotalPrecioConDto | currency}}</strong></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </template>
                <template v-else>
                    <div v-if="isLoadingCurrent" class="alert alert-warning">
                        <i class="fa fa-spinner fa-spin"></i> {{$t("cargandoDatos")}}...
                    </div>
                    <div v-else-if="!searchPerformed" class="alert" style="background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%); color: #ecf0f1;">
                        {{$t("clickConsultarParaRealizarBusqueda")}}
                    </div>
                    <div v-else class="alert alert-danger" role="alert">
                        {{$t("noHayVentasDeProductosEnEsteRangoDeFechas")}}
                    </div>
                </template>
            </div>

            <div class="col-md-3 " v-show="this.list.length > 0 && respuesta && permiso">

                <div class="card">

                    <div class="chart-container col-md-12" style="height:300px; width: 100%">
                        <canvas id="chart"></canvas>
                    </div>

                </div>
            </div>

            <modal name="filtradoTPV" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{$t("filtrarPorTPV")}}</h4>
                    </div>
                    <div class="modal-body">

                        <el-checkbox-group :min="1" v-model="idsTPV" size="medium">
                            <el-checkbox v-for="tpv in listCheckBoxTpv" :label=tpv.id :key="tpv.id" border>
                                {{tpv.nameShow}}
                            </el-checkbox>
                        </el-checkbox-group>


                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button class="btn btn-primary" @click="getSalesProducts()"><i class="fa fa-search"></i>
                                {{$t("filtrarTPV")}}
                            </button>
                        </div>
                    </div>
                </div>
            </modal>

        </div>
    </div>

</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {
        DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button,
        Checkbox,
        CheckboxGroup
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
    import bus from '../../../../bus'
    import { mapState, mapMutations } from 'vuex'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", "Ventas materias primas");

            if (this.modoSectores) {
                if (this.listaSectores.length > 0) {
                    this.idSector = this.listaSectores[0].id;
                    this.getBusinessesBySector();
                } else {
                    this.getSectores();
                }
            } else {
                this.getBusiness();
            }

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }

            // bus.$on('get-ventas', (item) => {


            //     this.getVentas();
            // });

            bus.$on('get-business', (idBusiness) => {
                this.idBusiness = idBusiness;
                this.idsTPV = [];
                this.idTpv = 0;

                this.getTpv();


            });
            bus.$on('get-tpv', (idTpv) => {
                this.idTpv = idTpv;


                this.changeTPV();


            });

            // bus.$on('get-date', (dates) => {
            //     this.value4 = dates;


            //     this.getSalesProducts();

            // });

            bus.$on('get-open-modal', (item) => {
                this.openModal();

            });

        },
        components: {
            //CabeceraInformes,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            CabeceraInformes
        },
        data() {
            return {
                searchPerformed: false,
                // Peticiones en curso ahora mismo, una entrada por combinación
                // negocio+TPV+fechas+etiqueta. Permite consultar varias configuraciones en
                // paralelo (setear -> pedir -> cambiar de config -> pedir otra vez) sin que
                // se bloqueen ni se pisen entre sí.
                loadingKeys: {},
                // Última versión de petición lanzada para cada combinación, para ignorar
                // respuestas obsoletas si se pulsa "Consultar" varias veces seguidas para la
                // misma configuración.
                requestVersions: {},
                // Cache en memoria POR CONTEXTO
                // (negocio + TPVs + fechas) y, dentro de cada contexto, por etiqueta.
                // Forma: { [huellaContexto]: { [idFiltro]: { data, timestamp } } }
                requestCache: {},
                lastUpdated: null,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                idBusiness: 0,
                // Solo en modo sectores: con idBusiness = -1 se consultan todos los negocios del sector
                idSector: 0,
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                list: [],
                mode: 0,
                $Chart: null,
                objectChart: null,
                contador: 0,
                chartIn: 0,
                listTpv: [],
                idTpv: 0,
                dateRangeOptions1: {
                    firstDayOfWeek: 1

                },
                listCheckBoxTpv: [],
                idsTPV: [],
                nombreFiltro: "none",

                ordenacionProductos: 0,
                ordenacionBarcode: 0,
                ordenacionProveedor: 0,
                ordenacionTag: 0,
                ordenarCantidad: 0,
                ordenarCosto: 0,
                ordenarImporte: 0,
                ordenarPrecioMed: 0,
                ordenarTipo: 0,
                ordenarCosteConDto: 0,

                respuesta: true,

                //FILTRO
                filterTag: [],
                idFiltro: 0,
            }
        },
        computed: {
            ...mapState(["permiso", "sectores", "listaSectores"]),
            // Al recargar la página el flag del store llega tarde (App.vue lo carga en asíncrono),
            // así que basta con la cookie que se pone en el login
            modoSectores() {
                return this.sectores || this.$cookies.isKey('sectores');
            },
            sectorActual() {
                return (this.listaSectores || []).find(sector => sector.id == this.idSector);
            },
            // Negocio que se envía al API. Con un sector seleccionado (idBusiness = -1) es el
            // maestro del sector: contra él se comprueban permisos y se leen las etiquetas.
            // El sector "Ver negocios sin sector" (id 0) no tiene maestro y usa su primer negocio.
            idBusinessConsulta() {
                if (this.idBusiness != -1) {
                    return this.idBusiness;
                }
                if (this.sectorActual && this.sectorActual.idBusinessMaster) {
                    return this.sectorActual.idBusinessMaster;
                }
                return this.listBusinesses.length > 0 ? this.listBusinesses[0].id : 0;
            },
            urlExportPDF() {
                return this.getUrlExport("PDF");
            },
            urlExportExcel() {
                return this.getUrlExport("Excel");
            },


            getTotalPrecio() {
                let total = 0;
                this.list.forEach(function (d) {

                    if( d.escandallo > 1){
                        total += (d.precioCompra/d.escandallo) *d.units;
                    }else{
                        total += d.precioCompra * d.units;
                    }

                });
                return total;
            },
            getTotalPrecioConDto() {
                let total = 0;
                this.list.forEach(function (d) {

                    if( d.escandallo > 1){
                        total += (d.precioCompraConDto/d.escandallo) * d.units;
                    }else{
                        total += d.precioCompraConDto * d.units;
                    }

                });
                return total;
            },
            lastUpdatedFormatted() {
                if (!this.lastUpdated) {
                    return '';
                }
                return moment(this.lastUpdated).format('DD/MM/YYYY HH:mm');
            },
            // Clave de la configuración (negocio+TPV+fechas+etiqueta) que se está viendo ahora
            // mismo, para saber si hay una petición en curso para ELLA en concreto.
            currentCacheKey() {
                return this.getCacheKey(this.getQueryFingerprint(), this.idFiltro);
            },
            isLoadingCurrent() {
                return !!this.loadingKeys[this.currentCacheKey];
            },
            hayConsultasEnCurso() {
                return Object.values(this.loadingKeys).some(Boolean);
            }
        },
        methods: {
            ...mapMutations(['changeListaSectores']),

            getUrlExport(tipo) {
                let url = this.$store.getters.apiUrl + "subproducts/exportVentasMateriaPrima/" + tipo
                    + "?idBusiness=" + this.idBusinessConsulta
                    + "&idFilter=" + this.idFiltro
                    + "&nombreFiltro=" + encodeURIComponent(this.nombreFiltro)
                    + "&idTpv=" + this.idsTPV.join(',')
                    + "&datefrom=" + moment(this.datefrom).startOf("day").unix()
                    + "&dateto=" + moment(this.dateto).endOf("day").unix()
                    + "&jwt=" + this.$store.getters.jwt;

                if (this.idBusiness == -1 && this.sectorActual) {
                    url += "&sector=" + encodeURIComponent(this.sectorActual.name);
                }

                return url;
            },

            cambioSector(idSectorData, listBusinesses) {
                if (listBusinesses) {
                    this.listBusinesses = listBusinesses;
                }

                this.idSector = idSectorData;
                this.idBusiness = -1;
                this.getAllTpvFromBusinesses();
            },

            getBusinessesBySector() {
                const config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                const params = {
                    idBusiness: this.sectorActual ? this.sectorActual.idBusinessMaster : this.listaSectores[0].idBusinessMaster,
                    idSector: this.idSector,
                    jwt: this.$store.getters.jwt,
                };

                let vm = this;
                this.axios.post(this.$store.getters.apiUrl + "general/getBusinessesBySector", params, config)
                    .then(function (response) {
                        if (response.data.response) {
                            // La cabecera detecta idBusiness = -1 y carga los TPVs de todos estos
                            // negocios, devolviéndolos por cambioBusiness(-1, listTpv)
                            vm.listBusinesses = response.data.result;
                            vm.idBusiness = -1;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getAllTpvFromBusinesses() {
                const businesses = this.listBusinesses
                    .filter(business => business.id != -1)
                    .map(business => parseInt(business.id));

                const config = {
                    params: {
                        idBusiness: businesses,
                        jwt: this.$store.getters.jwt,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByListBusiness", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listCheckBoxTpv = response.data.result;
                            vm.cambioBusiness(-1, response.data.result.map(tpv => ({
                                nameShow: tpv.nameShow,
                                id: tpv.id
                            })));
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getSectores() {
                const config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesSectors", config)
                    .then(function (response) {
                        if (response.data.response && response.data.result["sectores"].length > 0) {
                            response.data.result["sectores"].forEach((sector) => {
                                sector.idBusinessMaster = parseInt(sector.idBusinessMaster);
                                sector.id = parseInt(sector.id);
                            });

                            vm.changeListaSectores(response.data.result["sectores"]);
                            vm.idSector = vm.listaSectores[0].id;
                            vm.getBusinessesBySector();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            cambioBusiness(idBusinessData, listTpv) {
                if (listTpv) {
                    this.listTpv = listTpv;
                }

                this.idBusiness = idBusinessData;
                this.idTpv = -1;
                this.idFiltro = 0;
                this.respuesta = true;
                this.changeTPV();
                this.getCategory();

                // Si ya consultamos este negocio (con este mismo rango de fechas) antes en
                // esta misma visita, lo mostramos al instante en vez de pedirlo otra vez.
                if (!this.resolveFiltroFromCache(this.getQueryFingerprint())) {
                    this.list = [];
                    this.searchPerformed = false;
                }
            },

            emitirConsulta() {
                this.getSalesProducts();
            },

            // Huella del contexto (negocio + TPVs + fechas).
            getQueryFingerprint() {
                const tpvKey = (this.idsTPV || []).slice().sort((a, b) => a - b).join(',');
                const desde = moment(this.datefrom).startOf('day').unix();
                const hasta = moment(this.dateto).endOf('day').unix();
                return this.idBusinessConsulta + '|' + tpvKey + '|' + desde + '|' + hasta;
            },

            // Nombre "plano" de una etiqueta
            // filterTag guarda nombres compuestos tipo "Padre -> Hijo" para las anidadas
            // nos quedamos con el ultimo tramo
            nombrePlanoEtiqueta(tagEntry) {
                const partes = (tagEntry.name || '').split(' -> ');
                return partes[partes.length - 1];
            },

            // Devuelve el conjunto de nombres (la etiqueta elegida + todas sus hijas,
            getNombresEtiquetaConHijas(idFiltro) {
                const seleccionada = this.filterTag.find(t => t.id == idFiltro);
                if (!seleccionada) {
                    return null;
                }

                const nombres = new Set([this.nombrePlanoEtiqueta(seleccionada)]);
                const codigosPorExpandir = [seleccionada.code];

                while (codigosPorExpandir.length > 0) {
                    const code = codigosPorExpandir.pop();
                    this.filterTag.forEach(t => {
                        if (t.id != 0 && t.parentCode === code) {
                            nombres.add(this.nombrePlanoEtiqueta(t));
                            codigosPorExpandir.push(t.code);
                        }
                    });
                }

                return nombres;
            },

            // Filtra una lista ya cargada ("Todas las etiquetas")
            filtrarListaPorEtiqueta(lista, idFiltro) {
                if (idFiltro == 0) {
                    return lista;
                }

                const nombres = this.getNombresEtiquetaConHijas(idFiltro);
                if (!nombres) {
                    return lista;
                }

                return lista.filter(item => nombres.has(item.nameTag));
            },

            // Clave de una combinación negocio+TPV+fechas+etiqueta, para rastrear peticiones
            // en curso y versiones de petición de forma independiente por configuración.
            getCacheKey(fingerprint, idFiltro) {
                return fingerprint + '#' + idFiltro;
            },

            // Bucket de cache (negocio+TPVs+fechas).
            getCacheBucket(fingerprint) {
                if (!this.requestCache[fingerprint]) {
                    this.requestCache[fingerprint] = {};
                }
                return this.requestCache[fingerprint];
            },

            // Intenta observar, en base a las reglas configuradas, si ya tenemos una consulta
            // guardada en cache para evitar que el usuario sienta la necesidad de recargar
            resolveFiltroFromCache(fingerprint) {
                const bucket = this.requestCache[fingerprint];
                if (!bucket) {
                    return false;
                }

                if (Object.prototype.hasOwnProperty.call(bucket, this.idFiltro)) {
                    const entry = bucket[this.idFiltro];
                    this.list = entry.data;
                    this.lastUpdated = entry.timestamp;
                    this.respuesta = true;
                    this.searchPerformed = true;
                    this.initChart();
                    return true;
                }

                if (this.idFiltro != 0 && Object.prototype.hasOwnProperty.call(bucket, 0)) {
                    const entryTodas = bucket[0];
                    const derivada = this.filtrarListaPorEtiqueta(entryTodas.data, this.idFiltro);
                    // con "Derivada", nos referimos a que las etiquetas recibidas cuando se obtiene
                    // el conjunto completo con "Todas", heredan la hora de la consulta para indicar
                    // que YA tenemos toda la info
                    bucket[this.idFiltro] = { data: derivada, timestamp: entryTodas.timestamp };
                    this.list = derivada;
                    this.lastUpdated = entryTodas.timestamp;
                    this.respuesta = true;
                    this.searchPerformed = true;
                    this.initChart();
                    return true;
                }

                return false;
            },

            // Al cambiar de etiqueta sin pulsar "Consultar": si ya la podemos resolver desde
            // cache (tal cual o derivada de "Todas las etiquetas") para el setup de busqueda
            // que tenemos configurado actualmente. En caso contrario, limpiamos y pedimos que
            // consulte otra vez, la
            onFiltroChange() {
                this.selectNombreFiltro();

                if (!this.resolveFiltroFromCache(this.getQueryFingerprint())) {
                    this.list = [];
                    this.searchPerformed = false;
                }
            },

            cambioTpv(idTpvData, filtrar) {

                if (idTpvData != undefined) {
                    this.idTpv = idTpvData;
                }

                this.changeTPV();

                // Si ya consultamos este TPV (con este negocio y fechas) antes en esta misma
                // visita, lo mostramos al instante en vez de pedirlo otra vez.
                if (!this.resolveFiltroFromCache(this.getQueryFingerprint())) {
                    this.list = [];
                    this.searchPerformed = false;
                }
            },

            cambioHora(dates) {
                this.datefrom = dates[0]
                this.dateto = dates[1]

                // Las fechas forman parte de la huella de cada consulta cacheada: al
                // cambiarlas, todo lo que había cacheado para el rango anterior deja de ser
                // alcanzable igualmente (huella distinta), así que lo limpiamos ya para no
                // acumular memoria sin necesidad.
                this.requestCache = {};
            },
            sortedArrayCostoASC: function () {
                this.ordenarCosto = 1;

                function compare(a, b) {
                    if ((a.precioCompra / a.escandallo) * a.units < (b.precioCompra / b.escandallo) * b.units)
                        return -1;
                    if ((a.precioCompra / a.escandallo) * a.units > (b.precioCompra / b.escandallo) * b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            selectNombreFiltro: function () {
                this.filterTag.forEach(t => {
                    if (t.id == this.idFiltro) {
                        this.nombreFiltro = t.name;
                    }
                });

                if (this.idFiltro == 0) {
                    this.nombreFiltro = "none";
                }
            },
            sortedArrayCostoDESC: function () {
                this.ordenarCosto = 0;

                function compare(a, b) {

                    if ((a.precioCompra / a.escandallo) * a.units > (b.precioCompra / b.escandallo) * b.units)
                        return -1;
                    if ((a.precioCompra / a.escandallo) * a.units < (b.precioCompra / b.escandallo) * b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },


            sortedArrayNameASC: function () {
                this.ordenacionProductos = 1;

                function compare(a, b) {
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameDESC: function () {
                this.ordenacionProductos = 0;

                function compare(a, b) {

                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameProveedorASC: function () {
                this.ordenacionProveedor = 1;

                function compare(a, b) {
                    if (a.nameProveedor.toUpperCase() < b.nameProveedor.toUpperCase())
                        return -1;
                    if (a.nameProveedor.toUpperCase() > b.nameProveedor.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameProveedorDESC: function () {
                this.ordenacionProveedor = 0;

                function compare(a, b) {

                    if (a.nameProveedor.toUpperCase() > b.nameProveedor.toUpperCase())
                        return -1;
                    if (a.nameProveedor.toUpperCase() < b.nameProveedor.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameTagASC: function () {
                this.ordenacionTag = 1;

                function compare(a, b) {
                    if (a.nameTag.toUpperCase() < b.nameTag.toUpperCase())
                        return -1;
                    if (a.nameTag.toUpperCase() > b.nameTag.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameTagDESC: function () {
                this.ordenacionTag = 0;

                function compare(a, b) {

                    if (a.nameTag.toUpperCase() > b.nameTag.toUpperCase())
                        return -1;
                    if (a.nameTag.toUpperCase() < b.nameTag.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayCantidadASC: function () {
                this.ordenarCantidad = 1;

                function compare(a, b) {
                    if (a.units < b.units)
                        return -1;
                    if (a.units > b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayCantidadDESC: function () {
                this.ordenarCantidad = 0;

                function compare(a, b) {

                    if (a.units > b.units)
                        return -1;
                    if (a.units < b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteASC: function () {
                this.ordenarImporte = 1;

                function compare(a, b) {
                    if (a.importe < b.importe)
                        return -1;
                    if (a.importe > b.importe)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteDESC: function () {
                this.ordenarImporte = 0;

                function compare(a, b) {

                    if (a.importe > b.importe)
                        return -1;
                    if (a.importe < b.importe)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayPrecioMedASC: function () {
                this.ordenarPrecioMed = 1;

                function compare(a, b) {
                    if (a.importe / a.cantidad < b.importe / b.cantidad)
                        return -1;
                    if (a.importe / a.cantidad > b.importe / b.cantidad)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayPrecioMedDESC: function () {
                this.ordenarPrecioMed = 0;

                function compare(a, b) {

                    if (a.importe / a.cantidad > b.importe / b.cantidad)
                        return -1;
                    if (a.importe / a.cantidad < b.importe / b.cantidad)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayTipoASC: function () {
                this.ordenarTipo = 1;

                function compare(a, b) {
                    if (a.type < b.type)
                        return -1;
                    if (a.type > b.type)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayTipoDESC: function () {
                this.ordenarTipo = 0;

                function compare(a, b) {

                    if (a.type > b.type)
                        return -1;
                    if (a.type < b.type)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayBarcodeASC: function () {
                this.ordenacionBarcode = 1;

                function compare(a, b) {
                    if (a.cod_ean.toUpperCase() < b.cod_ean.toUpperCase())
                        return -1;
                    if (a.cod_ean.toUpperCase() > b.cod_ean.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayBarcodeDESC: function () {
                this.ordenacionBarcode = 0;

                function compare(a, b) {
                    if (a.cod_ean.toUpperCase() > b.cod_ean.toUpperCase())
                        return -1;
                    if (a.cod_ean.toUpperCase() < b.cod_ean.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayCosteConDtoASC: function () {
                this.ordenarCosteConDto = 1;

                function compare(a, b) {
                    const costoA = a.escandallo > 1 ? (a.precioCompraConDto / a.escandallo) * a.units : a.precioCompraConDto * a.units;
                    const costoB = b.escandallo > 1 ? (b.precioCompraConDto / b.escandallo) * b.units : b.precioCompraConDto * b.units;
                    if (costoA < costoB)
                        return -1;
                    if (costoA > costoB)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayCosteConDtoDESC: function () {
                this.ordenarCosteConDto = 0;

                function compare(a, b) {
                    const costoA = a.escandallo > 1 ? (a.precioCompraConDto / a.escandallo) * a.units : a.precioCompraConDto * a.units;
                    const costoB = b.escandallo > 1 ? (b.precioCompraConDto / b.escandallo) * b.units : b.precioCompraConDto * b.units;
                    if (costoA > costoB)
                        return -1;
                    if (costoA < costoB)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            changeTPV() {
                if (this.idTpv === -1) {


                    this.idsTPV = [];

                    for (let i = 0; i < this.listTpv.length; i++) {

                        this.idsTPV.push(this.listTpv[i].id)
                    }
                }
                else {

                    this.idsTPV = []
                    this.idsTPV.push(this.idTpv)

                }
            },

            openModal() {

                this.$modal.show('filtradoTPV');

            },

            getTpv() {

                this.listTpv = [];

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                    .then(function (response) {
                        if (response.data.response) {


                            for (let i = 0; i < response.data.result.length; i++) {
                                vm.idsTPV.push(response.data.result[i].id)
                            }

                            vm.listCheckBoxTpv = response.data.result;

                            for (let i = 0; i < response.data.result.length; i++) {

                                let printername = {
                                    nameShow: response.data.result[i].nameShow,
                                    id: response.data.result[i].id
                                };

                                vm.listTpv.push(printername)
                            }

                            vm.getCategory();
                            // vm.getSalesProducts();

                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;

                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {
                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else {

                            vm.idBusiness = response.data.result[0].id;
                        }


                        vm.getTpv();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSalesProducts() {

                let vm = this;

                this.selectNombreFiltro();
                this.$modal.hide('filtradoTPV');

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return;
                }

                let secondsDesde = moment(this.datefrom).unix();
                let secondsHasta = moment(this.dateto).unix();

                if (secondsHasta < secondsDesde) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return;
                }

                this.$store.dispatch("setDateTo", this.dateto);
                this.$store.dispatch("setDateFrom", this.datefrom);

                const fingerprint = this.getQueryFingerprint();
                const requestedIdFiltro = this.idFiltro;
                // Clave de ESTA configuración concreta (negocio+TPV+fechas+etiqueta). Como el
                // seguimiento de la petición se hace por clave y no de forma global, se puede
                // consultar una config, cambiar a otra distinta y consultarla también sin que
                // se interrumpan entre sí: cada una se resuelve y se coloca en su sitio cuando
                // le toca.
                const key = this.getCacheKey(fingerprint, requestedIdFiltro);

                // Pulsar consultar siempre fuerza limpiado y relleno de la configuracion correspondiente
                if (requestedIdFiltro == 0) {
                    this.requestCache[fingerprint] = {};
                } else {
                    delete this.getCacheBucket(fingerprint)[requestedIdFiltro];
                }

                // Versión de esta petición para esta clave. Si se pulsa "Consultar" varias
                // veces seguidas para la MISMA configuración, solo nos importa la respuesta de
                // la última.
                const requestVersion = (this.requestVersions[key] || 0) + 1;
                this.$set(this.requestVersions, key, requestVersion);
                this.$set(this.loadingKeys, key, true);

                // Si la config que se acaba de lanzar es la que se está viendo ahora mismo,
                // ocultamos la lista anterior mientras se resuelve (si es otra config distinta
                // de la que tenemos delante, no tocamos lo que se está mostrando).
                if (this.currentCacheKey === key) {
                    this.searchPerformed = true;
                    this.list = [];
                }

                var config = {
                    params: {
                        idFilter: requestedIdFiltro,
                        idBusiness: this.idBusinessConsulta,
                        datefrom: moment(this.datefrom).startOf("day").unix(),
                        dateto: moment(this.dateto).endOf("day").unix(),
                        idTpv: this.idsTPV,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                this.$store.dispatch("setIdBusiness", this.idBusinessConsulta);
                this.axios.get(this.$store.getters.apiUrl + "subproducts/getSalesSubproducts", config)
                    .then(function (response) {
                        // Si se volvió a pulsar "Consultar" para esta misma configuración
                        // mientras esta petición seguía en vuelo, ya es obsoleta: se ignora.
                        if (vm.requestVersions[key] !== requestVersion) {
                            return;
                        }

                        vm.$set(vm.loadingKeys, key, false);

                        // ¿Sigue siendo la configuración que se está viendo ahora mismo?
                        const sigueVigente = vm.currentCacheKey === key;

                        if (response.data.response) {

                            const timestamp = Date.now();
                            // Guardamos SIEMPRE en caché bajo la etiqueta realmente solicitada, no la actual
                            vm.getCacheBucket(fingerprint)[requestedIdFiltro] = { data: response.data.result, timestamp: timestamp };

                            if (sigueVigente) {
                                vm.list = response.data.result;
                                vm.lastUpdated = timestamp;
                                vm.initChart();
                                vm.respuesta = true;
                            }

                        }else if (sigueVigente && response.data.response == false && response.data.rangoMayor == true) {
                            swal({
                            title: "Lo sentimos",
                            text: response.data.result,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "info",
                            });
                            vm.respuesta = false;
                        }
                        else if (sigueVigente) {
                            swal({
                                title: vm.$t('accesoDenegado'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                            vm.respuesta = false;

                        }

                    })
                    .catch(function (error) {
                        console.log(error);

                        if (vm.requestVersions[key] !== requestVersion) {
                            return;
                        }

                        vm.$set(vm.loadingKeys, key, false);
                    });
            },


            calcularUnidades(unidades, escandallo) {

                if (escandallo === 1) {
                    return unidades;
                }
                else if (escandallo === 0) {

                    return 0;

                } else {
                    return (unidades - (unidades % escandallo)) / escandallo;
                }

            },


            calcularPartes(unidades, escandallo) {


                if (escandallo === 1) {
                    return 0
                }
                else if (escandallo === 0) {

                    return 0;

                } else {
                    return unidades % escandallo;
                }


            },
            calcularEscandallo(escandallo) {


                if (escandallo === 1) {
                    return 0
                }
                else if (escandallo === 0) {

                    return 0;

                } else {
                    return  escandallo;
                }

            },
            
            getCategory() {
                var config = {
                    params: {
                        idBusiness: this.idBusinessConsulta,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                this.$store.dispatch("setIdBusiness", this.idBusinessConsulta);
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'subproducts/getTagsByBusiness', config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.filterTag = [];

                            if (response.data.result.length === 0) {

                                let category = {
                                    name: "Todas las etiquetas",
                                    id: 0,
                                    code: 0,
                                    parentCode: 0
                                };

                                vm.filterTag.push(category);

                            }

                            for (let i = 0; i < response.data.result.length; i++) {

                                if (i === 0) {

                                    let category = {
                                        name: "Todas las etiquetas",
                                        id: 0,
                                        code: 0,
                                        parentCode: 0
                                    };

                                    vm.filterTag.push(category);

                                }


                                let categoryname = {
                                    name: response.data.result[i].name,
                                    id: response.data.result[i].id,
                                    code: response.data.result[i].code,
                                    parentCode: response.data.result[i].parentCode
                                };

                                vm.filterTag.push(categoryname)

                            }

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },

            initChart() {


                var labels = this.list.map(function (x) {
                    return x.name;
                });

                var data = this.list.map(function (x) {
                    return x.units;
                });


                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador == 0) {

                    if (this.list.length > 0) {
                        this.objectChart = new Chart("chart", {

                            type: 'pie',
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: data,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                legend: {
                                    display: false,
                                    position: 'bottom',
                                },
                                maintainAspectRatio: false,

                            }
                        });


                        this.contador++;
                    }
                }
                else {

                    this.objectChart.destroy();

                    this.objectChart = new Chart('chart', {

                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            legend: {
                                display: false,
                                position: 'bottom',
                            },
                            maintainAspectRatio: false,


                        }
                    });

                }
            }
        }
    }
</script>

<style scoped>


    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

    body {
        background: #1D1F20;
        padding: 16px;
    }

    .chart-container {
        position: relative;
        margin: auto;
        height: 80vh;
        width: 80vw;
    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Subproductos/VentasSubproductos.vue